import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    Box,
    CircularProgress,
    Alert,
    List,
    ListItem,
    ListItemText,
    Divider,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const Dropzone = styled("label")(({ theme }) => ({
    border: "2px dashed #1976d2",
    borderRadius: "15px",
    backgroundColor: "#f5f5f5",
    width: "100%",
    height: "200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    position: "relative",
    overflow: "hidden",
    transition: "0.2s",
    textAlign: "center",
    padding: "20px",
    "&:hover": {
        backgroundColor: "#e3f2fd",
    },
    "& input": {
        position: "absolute",
        inset: 0,
        opacity: 0,
        cursor: "pointer",
    },
}));

const ImportEventsDialog = ({ token, open, onClose, selectedGroupCode }) => {
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [dragActive, setDragActive] = useState(false);

    useEffect(() => {
        if (!open) {
            setResult(null);
            setError(null);
            setLoading(false);
            setFileName(null);
        }
    }, [open]);

    const validateFile = (file) => {
        if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
            setError("Dozwolone są tylko pliki Excel (.xlsx, .xls)");
            return false;
        }
        return true;
    };

    const uploadFile = async (file) => {
        if (!validateFile(file)) return;

        setLoading(true);
        setError(null);
        setResult(null);
        setFileName(file.name);

        const formData = new FormData();
        formData.append("file", file);
        formData.append('groupCode', selectedGroupCode);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/import`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setResult(response.data);
        } catch (err) {
            setError(err?.response?.data?.message || "Import nie powiódł się");
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const file = e.target.files?.[0];
        if (file) uploadFile(file);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragActive(false);
        const file = e.dataTransfer.files?.[0];
        if (file) uploadFile(file);
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Import wydarzeń z pliku Excel</DialogTitle>

            <DialogContent dividers>
                <Alert severity="info" sx={{ mb: 3 }}>Wydarzenia zostaną dodane do aktualnie wybranej grupy.</Alert>

                <Box display="flex" flexDirection="column" gap={3}>
                    <Dropzone
                        onDragOver={(e) => {
                            e.preventDefault();
                            setDragActive(true);
                        }}
                        onDragLeave={() => setDragActive(false)}
                        onDrop={handleDrop}
                        sx={{
                            borderColor: dragActive ? "#1565c0" : "#1976d2",
                            backgroundColor: dragActive ? "#e3f2fd" : "#f5f5f5",
                        }}
                    >
                        <input
                            type="file"
                            accept=".xlsx,.xls"
                            onChange={handleInputChange}
                        />

                        {loading ? (
                            <Box>
                                <CircularProgress />
                                <Typography mt={2}>Importowanie...</Typography>
                            </Box>
                        ) : fileName ? (
                            <Typography>
                                Wybrany plik:
                                <br />
                                <strong>{fileName}</strong>
                            </Typography>
                        ) : (
                            <Typography>
                                Przeciągnij plik Excel tutaj
                                <br />
                                lub kliknij aby wybrać
                            </Typography>
                        )}
                    </Dropzone>

                    {result && (
                        <Box>
                            <Alert severity="success">
                                Utworzono: {result.createdCount}
                            </Alert>

                            {result.errorCount > 0 && (
                                <>
                                    <Box mt={2}>
                                        <Alert severity="warning">
                                            Błędy: {result.errorCount}
                                        </Alert>
                                    </Box>

                                    <Box
                                        mt={2}
                                        maxHeight={200}
                                        overflow="auto"
                                        border="1px solid #eee"
                                        borderRadius={1}
                                    >
                                        <List dense>
                                            {result.errors.map((err, index) => (
                                                <React.Fragment key={index}>
                                                    <ListItem>
                                                        <ListItemText
                                                            primary={`Wiersz ${err.row}`}
                                                            secondary={err.error}
                                                        />
                                                    </ListItem>
                                                    <Divider />
                                                </React.Fragment>
                                            ))}
                                        </List>
                                    </Box>
                                </>
                            )}
                        </Box>
                    )}

                    {error && <Alert severity="error">{error}</Alert>}
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    Zamknij
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ImportEventsDialog;



// import React, { useRef, useState } from "react";
// import axios from "axios";
// import { Button } from "@mui/material";

// const ImportEventsButton = ({ token }) => {
//     const fileInputRef = useRef(null);
//     const [loading, setLoading] = useState(false);
//     const [result, setResult] = useState(null);
//     const [error, setError] = useState(null);

//     const handleClick = () => {
//         fileInputRef.current?.click();
//     };

//     const handleFileChange = async (
//         e
//     ) => {
//         const file = e.target.files?.[0];
//         if (!file) return;

//         setLoading(true);
//         setError(null);
//         setResult(null);

//         const formData = new FormData();
//         formData.append("file", file);

//         try {

//             const response = await axios.post(
//                 `${process.env.REACT_APP_API_URL_VR_EDITOR}/events-schedule/import`,
//                 formData,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": "multipart/form-data",
//                     },
//                 }
//             );

//             setResult(response.data);
//         } catch (err) {
//             setError(
//                 err?.response?.data?.message || "Import failed"
//             );
//         } finally {
//             setLoading(false);
//             e.target.value = "";
//         }
//     };

//     return (
//         <div>
//             <Button variant="contained" onClick={handleClick} disabled={loading}>
//                 {loading ? "Importowanie..." : "Importuj wydarzenia z Excel"}
//             </Button>

//             <input
//                 type="file"
//                 accept=".xlsx,.xls"
//                 ref={fileInputRef}
//                 style={{ display: "none" }}
//                 onChange={handleFileChange}
//             />

//             {result && (
//                 <div style={{ marginTop: 10 }}>
//                     <p>Utworzono: {result.createdCount}</p>
//                     <p>Błędy: {result.errorCount}</p>

//                     {result.errors?.length > 0 && (
//                         <ul>
//                             {result.errors.map((err, index) => (
//                                 <li key={index}>
//                                     Wiersz {err.row}: {err.error}
//                                 </li>
//                             ))}
//                         </ul>
//                     )}
//                 </div>
//             )}

//             {error && (
//                 <div style={{ color: "red", marginTop: 10 }}>
//                     {error}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default ImportEventsButton;